<template>
  <div class="slideWrapper">
    <!-- indexslide当页面既不是   期刊也不是业务工作的时候 显示3科研与国际合作   2是业务工作  5是期刊 -->
    <div
      class="indexSlide"
      v-if="$route.meta.showFlag!='3'&&$route.meta.showFlag!='6'&&$route.meta.showFlag!='8'"
    >
      <div class="index-item index-item1" @touchend="toPage('/')">首页</div>

      <div
        class="index-item index-jiantou index-item2"
        :class="{'index-item-active':showFlag =='1'}"
        @touchend="showFlag ='1'"
      >中心概况
        <div class="hover-show">
          <div class="hover-show-item" @touchend="toPage({name:'centerIntro',query:{otype:1}})">中心简介</div>
          <div class="hover-show-item" @touchend="toPage({name:'centerIntro',query:{otype:2}})">组织架构图</div>
          <div class="hover-show-item" @touchend="toPage({name:'centerIntro',query:{otype:5}})">资质证书</div>
          <div class="hover-show-item" @touchend="toPage({name:'centerIntro',query:{otype:3}})">中心领导</div>
          <!-- <div class="hover-show-item" @touchend="toPage({name:'centerIntro',query:{otype:4}})">部门职责</div> -->
        </div>
      </div>

      <div
        class="index-item index-jiantou index-item3"
        :class="{'index-item-active':showFlag =='2'}"
        @touchend="showFlag ='2'"
      >党群建设
        <div class="hover-show">
          <div class="hover-show-item" @touchend="toPage({name:'comPartyList',query:{section:'2'}})">党建动态</div>
          <div class="hover-show-item" @touchend="toPage({name:'comPartyList',query:{section:'3'}})">党风廉政</div>
          <div class="hover-show-item" @touchend="toPage({name:'comPartyList',query:{section:'4'}})">群团建设</div>
          <div class="hover-show-item" @touchend="toPage({name:'comPartyList',query:{section:'5'}})">图片新闻</div>
        </div>
      </div>

       <div
        class="index-item index-jiantou index-item4"
        :class="{'index-item-active':showFlag =='3'}"
        @touchend="showFlag ='3'"
      >海洋标准化
        <div class="hover-show">
          <div
                  class="hover-show-item"
                  v-for="item in titleList[0]&&titleList[0].sub"
                  :key="item.id"
                  @touchend="toPage({name:'BusinessIntro',query:{type:1,firstId:item.id,workinfoId:item.sub[0]&&item.sub[0].id}})"
                >{{item.title}}</div>
        </div>
      </div>

      <div
        class="index-item index-jiantou index-item5"
        :class="{'index-item-active':showFlag =='4'}"
        @touchend="showFlag ='4'"
      >海洋计量
        <div class="hover-show">
          <div
                  class="hover-show-item"
                  v-for="item in titleList[2]&&titleList[2].sub"
                  :key="item.id"
                  @touchend="toPage({name:'BusinessIntro',query:{type:2,firstId:item.id,workinfoId:item.sub[0]&&item.sub[0].id}})"
                >{{item.title}}</div>
        </div>
      </div>

      <div
        class="index-item index-jiantou index-item6"
        :class="{'index-item-active':showFlag =='5'}"
        @touchend="showFlag ='5'"
      >海洋质量监督
        <div class="hover-show">
          <div
                  class="hover-show-item"
                  v-for="item in titleList[1]&&titleList[1].sub"
                  :key="item.id"
                  @touchend="toPage({name:'BusinessIntro',query:{type:3,firstId:item.id,workinfoId:item.sub[0]&&item.sub[0].id}})"
                >{{item.title}}</div>
        </div>
      </div>

      <div
        class="index-item index-jiantou index-item7"
        :class="{'index-item-active':showFlag =='6'}"
        @touchend="showFlag ='6'"
      >科研与国际合作
        <div class="hover-show">
          <div
            class="hover-show-item"
            @touchend="toPage({name:'CooperMajor', query: {
            showFlag2: 0,
            type: 1
          }})"
          >重大专项</div>
          <div
            class="hover-show-item"
            @touchend="toPage({name:'CooperMajor', query: {
            showFlag2: 1,
            type: 2
          }})"
          >国际合作</div>
          <div
            class="hover-show-item"
            @touchend="toPage({name:'CooperMajor', query: {
            showFlag2: 2,
            type: 3
          }})"
          >科研项目管理</div>
        </div>
      </div>

      <div
        class="index-item index-jiantou index-item8"
        :class="{'index-item-active':showFlag =='7'}"
        @touchend="showFlag ='7'"
      >人才队伍
        <div class="hover-show">
          <!-- <div class="hover-show-item" @touchend="toPage({name:'education'})">教育培训</div> -->
          <div class="hover-show-item" @touchend="toPage({name:'recruitment'})">人才招聘</div>
        </div>
      </div>

      <!-- <div class="index-item index-item6" @touchend="toPage('/journal')">期刊</div> -->
    </div>
    <!-- businessWrapper当页面是 业务工作的时候显示 3是业务工作-->
    <div class="businessWrapper" v-if="$route.meta.showFlag=='3'">
      <div class="busi-top" @touchend="toPage('/')">返回首页</div>
      <div class="busi-list">
        <ul>
          <li v-for="(item,index) in titleList" :key="index" class="li-item">
            <div class="first-title" @touchend="changeBusinessFlag(item)">
              {{item.title}}
              <span class="circle"></span>
            </div>
            <div class="second-wrapper" v-show="item.id ==businessFlag">
              <div
                v-for="(childItem,index_2) in item.sub"
                :key="index_2"
                class="second-title"
                @touchend="toPage({name: 'BusinessIntro',query: {
                  series:item.id,
                  type: $route.query.type,
          workinfoId: childItem.id,
        }
      })"
              >
                <div class="second-title-style">{{childItem.title}}</div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <!-- journalWrapper当页面是 业务工作的时候显示 5是期刊-->
    <div class="businessWrapper" v-if="$route.meta.showFlag=='8'">
      <div class="busi-top" @touchend="toPage('/')">返回首页</div>
      <div class="busi-list">
        <ul>
          <li v-for="(item,index) in qikanList" :key="index" class="li-item">
            <div class="first-title" @touchend="changeFlag(item.year)">
              第{{item.year}}年期刊
              <span class="circle"></span>
            </div>
            <div class="second-wrapper" v-show="item.year == firstFlag">
              <div
                v-for="(childItem,index_2) in item.nums"
                :key="index_2"
                class="second-title"
                @touchend="toPage({name:'JournalDetail',query:{id:childItem.journal_id,year:childItem.year,num:childItem.num}})"
              >
                <div class="second-title-style">第{{childItem.num}}期 期刊</div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <!-- 科研月国际合作 -->
    <div class="businessWrapper" v-if="$route.meta.showFlag=='6'">
      <div class="busi-top" @touchend="toPage('/')">返回首页</div>
      <div class="busi-list">
        <ul>
          <li v-for="(item,index) in keyanList" :key="index" class="li-item">
            <div
              v-if="item.child.length !=0"
              class="first-title"
              :class="{'first-title-active':item.showFlag2 ==firstFlag2}"
              @click="changeFlag2(item.showFlag2)"
            >
              {{item.title}}
              <span class="circle"></span>
            </div>
            <div
              v-if="item.child.length ==0"
              class="first-title"
              :class="{'first-title-active':item.showFlag2 ==firstFlag2}"
              @click="changeSecondFlag(item.showFlag2,item.type)"
            >
              {{item.title}}
              <span class="circle"></span>
            </div>
            <div class="second-wrapper" v-show="item.showFlag2 == firstFlag2">
              <div
                v-for="(childItem,index_2) in item.child"
                :key="index_2"
                class="second-title"
                @touchend="changeSecondFlag(item.showFlag2,childItem.type)"
              >
                <div class="second-title-style">{{childItem.title}}</div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import { userApi } from "@/api/user.js";
export default {
  data() {
    return {
      showFlag: "-1",
      businessFlag: "-1",
      nowYear: new Date().getFullYear(),
      nowMonth: new Date().getMonth(),
      indexSlide: [
        {
          title: "首页",
          name: "Index",
          children: []
        },
        {
          title: "中心概况",
          name: "centerIntro",
          children: [
            {
              title: "中心简介",
              name: "centerIntro"
            },
            {
              title: "组织架构图",
              name: "centerMap"
            },
            {
              title: "中心领导",
              name: "centerLeader"
            },
            {
              title: "部门职责",
              name: "centerDuty"
            }
          ]
        },
        {
          title: "党政建设",
          name: "comPartyList",
          children: []
        },
        {
          title: "业务工作",
          name: "centerIntro",
          children: [
            {
              title: "计量检测实验室简介",
              name: "centerIntro"
            },
            {
              title: "计量检测对外服务",
              name: "centerMap"
            },
            {
              title: "标准化技术归口管理",
              name: "centerLeader"
            },
            {
              title: "全国海洋标准化技术委员会",
              name: "centerDuty"
            },
            {
              title: "国家计量认证海洋评审组",
              name: "centerDuty"
            },
            {
              title: "全国海洋专业计量器具计量技术委员会",
              name: "centerDuty"
            },
            {
              title: "质量监督管理",
              name: "centerDuty"
            }
          ]
        },
        {
          title: "科研与国际合作",
          name: "CooperMajor",
          children: [
            {
              title: "重大专项",
              name: "CooperMajor"
            },
            {
              title: "国际合作",
              name: "interCooper"
            },
            {
              title: "科研项目管理",
              name: "manageMent"
            }
          ]
        },
        {
          title: "期刊",
          name: "JournalList",
          children: []
        }
      ],
      titleList: [],
      qikanList: [],
      keyanList: [
        {
          title: "重大专项",
          routerName: "CooperMajor",
          showFlag2: "0",
          type: "1",
          child: []
        },
        {
          title: "国际合作",
          routerName: "interCooper",
          showFlag2: "1",
          type: "2",
          child: []
        },
        {
          title: "科研项目管理",
          routerName: "manageMent",
          showFlag2: "2",
          child: [
            {
              title: "管理规定",
              type: "3"
            },
            {
              title: "完成的主要科研项目介绍",
              type: "4"
            },
            {
              title: "获奖项目清单",
              type: "5"
            },
            {
              title: "常用文件下载",
              type: "6"
            }
          ]
        }
      ],
      firstFlag: "",
      firstFlag2:'',
      secondFlag2:''

    };
  },
  methods: {
    ...mapActions(["openMenu", "closeMenu"]),
    changeFlag2(showFlag2) {
      this.secondFlag2 = "-1";
      this.firstFlag2 = showFlag2;
    },
    changeSecondFlag(showFlag2, type) {
      this.firstFlag2 = showFlag2;
      this.secondFlag2 = type;
      this.$router.push({
        name: "CooperMajor",
        query: {
          showFlag2: showFlag2,
          type: type
        }
      });
    },
    getSlideList() {
      userApi.getjournalperiod().then(res => {
        this.qikanList = res.data;
        if (this.$route.query.year) {
          this.firstFlag = this.$route.query.year;
        } else {
          this.firstFlag = this.qikanList[0].year;
        }
      });
    },
    getBusinessList() {
      userApi.workperiod({type: this.$route.query.type}).then(res => {
        this.titleList = res.data;
        if (this.$route.query.series) {
          this.businessFlag = this.$route.query.series;
        } else {
          this.businessFlag = this.titleList[0].id;
        }
      });
    },
    toPage(url) {
      this.closeMenu();
      if(url.name === "BusinessIntro"&&url.query.type === 1){
        //跳转指定外链
        if(url.query.firstId==='41'){
          window.open('http://www.ncosm.org.cn/ncosm/portal/index#page4')
        }else if(url.query.firstId==='4'){
          window.open('http://www.ncosm.org.cn/ncosm/portal/index')
        }else if(url.query.firstId==='44'){
          window.open('http://web.ncosm.org.cn/#/linkPage')
        }{
          this.$router.push(url);
        }
      }else{
        this.$router.push(url);
      }
    },
    changeFlag(index) {
      this.firstFlag = index;
    },
    changeBusinessFlag(item) {
      this.businessFlag = item.id;
      if(item.sub.length<=0){
        this.toPage({name: 'BusinessIntro',query: {
                  firstId:item.id,
                  type: this.$route.query.type
        }
      })
      }
    }
  },
  mounted() {
    // 期刊的侧边栏
    this.getSlideList();
    // 业务工作的侧边栏
    this.getBusinessList();
    // 判断展开那个侧边栏
    this.showFlag = this.$route.meta.showFlag
      ? this.$route.meta.showFlag
      : "-1";
      this.firstFlag2 = this.$route.query.showFlag2;
      this.secondFlag2 = this.$route.query.type;
  }
};
</script>

<style lang="less" scoped>
@import "../../common/minix.less";
// 业务工作的css
.businessWrapper {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: #dbe0ea;
  color: #fff;
  font-size: 24 / @rem;
  border-left: 1px solid rgba(94, 124, 193, 1);
  display: flex;
  flex-direction: column;
  .busi-top {
    width: 100%;
    height: 100 / @rem;
    background: #284faa;
    color: #fff;
    border-bottom: 1px solid rgba(94, 124, 193, 1);
    //   height: 100 / @rem;
    padding-left: 60 / @rem;
    position: relative;
    line-height: 100 / @rem;
    width: 100%;
    box-sizing: border-box;
  }
  .busi-top:after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 60 / @rem;
    height: 100 / @rem;
    background: url(/static/img/s-icon1.png) no-repeat center center;
    background-size: 34 / @rem 31 / @rem;
  }
  .busi-list {
    flex: 1;
    overflow-y: auto;
    box-sizing: border-box;
    .li-item {
      padding-left: 50 / @rem;
    }
    .first-title {
      font-size: 28 / @rem;
      width: 100%;
      height: 100 / @rem;
      line-height: 45 / @rem;
      padding-right: 20 / @rem;
      border-bottom: 1px solid #cdd7e2;
      color: #292929;
      box-sizing: border-box;
      position: relative;
      display: flex;
      align-items: center;
    }
    .first-title .circle {
      position: absolute;
      top: 50%;
      left: -30 / @rem;
      width: 20 / @rem;
      height: 20 / @rem;
      transform: translateY(-50%);
      background: #fff;
      border: 3 / @rem solid #1e4cb0;
      border-radius: 50%;
      box-sizing: border-box;
    }

    .second-title {
      width: 100%;
      height: 80 / @rem;
      display: table;
      position: relative;
      padding-right: 20 / @rem;
      box-sizing: border-box;
      color: #6e6e6e;
    }
    .second-title-style {
      height: 80 / @rem;
      display: table-cell;
      vertical-align: middle;
      line-height: 30 / @rem;
      padding-left: 4 / @rem;
      box-sizing: border-box;
    }
  }
}
.slideWrapper {
  height: 100%;
  overflow: hidden;
  position: relative;
}
.indexSlide {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background: #284faa;
  color: #fff;
  font-size: 24 / @rem;
  border-left: 1px solid rgba(94, 124, 193, 1);
}
.index-item {
  border-bottom: 1px solid rgba(94, 124, 193, 1);
  //   height: 100 / @rem;
  padding-left: 85 / @rem;
  position: relative;
  line-height: 100 / @rem;
  width: 100%;
  box-sizing: border-box;
}
.index-jiantou::before {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  width: 60 / @rem;
  height: 100 / @rem;
  background: url(/static/img/s-down.png) no-repeat center center;
  background-size: 18 / @rem 18 / @rem;
}
.index-item-active::before {
  background: url(/static/img/s-up.png) no-repeat center center;
  background-size: 19 / @rem 19 / @rem;
}
.hover-show {
  display: none;
  box-sizing: border-box;
}
.index-item-active {
  border-bottom: none;
}
.index-item-active .hover-show {
  display: block;
  width: 100%;
  border-top: 1px solid rgba(94, 124, 193, 1);
}
.index-item::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 85 / @rem;
  height: 100 / @rem;
}
.hover-show-item {
  height: 100 / @rem;
  padding-right: 30 / @rem;
  line-height: 40 / @rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.index-item1::after {
  background: url(/static/img/s-icon1.png) no-repeat center center;
  background-size: 34 / @rem 31 / @rem;
}
.index-item2::after {
  background: url(/static/img/s-icon2.png) no-repeat center center;
  background-size: 34 / @rem 31 / @rem;
}
.index-item3::after {
  background: url(/static/img/home-icon7.png) no-repeat center center;
  background-size: 34 / @rem 31 / @rem;
}
.index-item4::after {
  background: url(/static/img/s-icon3.png) no-repeat center center;
  background-size: 32 / @rem 32 / @rem;
}
.index-item5::after {
  background: url(/static/img/s-icon6.png) no-repeat center center;
  background-size: 31 / @rem 34 / @rem;
}
.index-item6::after {
  background: url(/static/img/home-icon8.png) no-repeat center center;
  background-size: 31 / @rem 34 / @rem;
}
.index-item7::after {
  background: url(/static/img/home-icon4.png) no-repeat center center;
  background-size: 31 / @rem 31 / @rem;
}
.index-item8::after {
  background: url(/static/img/home-icon5.png) no-repeat center center;
  background-size: 34 / @rem 31 / @rem;
}
</style>




// WEBPACK FOOTER //
// src/components/common/indexSlide.vue